"use client";
import * as React from "react";
const SvgInfoRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 12a.8.8 0 0 1-.8-.8V8c0-.44.36-.8.8-.8s.8.36.8.8v3.2a.8.8 0 0 1-.8.8m.8-7.2a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0" }));
export {
  SvgInfoRound as default
};
